(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fi-password-gate"]) return;
  try {
    
  (() => {
    const initIntro = () => {
      document.querySelectorAll('[data-fi-intro]').forEach((intro) => {
        if (intro.dataset.ready === 'true') return;
        intro.dataset.ready = 'true';
        const start = intro.querySelector('[data-fi-intro-start]');
        if (!start) return;

        start.addEventListener('click', () => {
          start.disabled = true;
          intro.classList.add('is-playing');
        }, { once: true });

        intro.addEventListener('animationend', (event) => {
          if (event.target === intro && intro.classList.contains('is-playing')) {
            intro.hidden = true;
          }
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initIntro, { once: true });
    } else {
      initIntro();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fi-site-header"]) return;
  try {
    
(() => {
  const drawer = document.getElementById('FiMenuDrawer');
  const trigger = document.querySelector('.fi-menu-trigger');
  if (!drawer || !trigger) return;

  const close = drawer.querySelector('.fi-drawer__close');

  const openDrawer = () => {
    drawer.showModal();
    document.documentElement.classList.add('fi-menu-open');
  };

  const closeDrawer = () => {
    drawer.close();
    document.documentElement.classList.remove('fi-menu-open');
  };

  trigger.addEventListener('click', openDrawer);
  close?.addEventListener('click', closeDrawer);

  drawer.addEventListener('click', (event) => {
    if (event.target === drawer) closeDrawer();
  });

  drawer.addEventListener('cancel', () => {
    document.documentElement.classList.remove('fi-menu-open');
  });

  drawer.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', closeDrawer);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
